export type CamelCase<T extends string> = T extends `${infer A}_${infer B}` ? `${A}${CamelCase<Capitalize<B>>}` : T;

export type CamelCaseKeys<T extends object> = {
  [key in keyof T as key extends string ? CamelCase<key> : key]: T[key];
};

export function snakeToCamel<T extends object>(obj: T): CamelCaseKeys<T>;
export function snakeToCamel(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map((val) => snakeToCamel(val));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = key.replace(/_\w/g, (m) => m[1].toUpperCase());
      acc[camelKey] = snakeToCamel(obj[key]);
      return acc;
    }, {} as any);
  } else {
    return obj;
  }
}
